import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import { generateUrl } from 'data/utils';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { GetAllArchivedGroupsUseCaseInterface } from 'domain/usecases';

export class RemoteGetAllArchivedGroups
  implements GetAllArchivedGroupsUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<GetAllArchivedGroupsUseCaseInterface.Result>,
  ) {}

  async execute(
    params: GetAllArchivedGroupsUseCaseInterface.Params,
  ): Promise<GetAllArchivedGroupsUseCaseInterface.Result> {
    const { page, length, ...restParams } = params;
    const requestUrl = `${this.url}/${page}/${length}`;

    const httpResponse = await this.httpClient.request({
      method: 'get',
      url: generateUrl(requestUrl, restParams),
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.forbidden:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body.message);
    }
  }
}
